import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

import { useStore } from 'vuex';
import { computed } from 'vue';
import BaseSpinner from '@/components/ui/BaseSpinner.vue';


export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const { getters } = useStore();
const isPending = computed<boolean>(() => getters['pending/isOn']);

return (_ctx: any,_cache: any) => {
  return (_unref(isPending))
    ? (_openBlock(), _createBlock(BaseSpinner, {
        key: 0,
        "for-app": ""
      }))
    : _createCommentVNode("", true)
}
}

})